<template>
    <div class="main">
        <p-header :title="headerTitle" left-btn="幫助" @onLeftBtn="onMessage" />
        <driver-item v-if="isDesignate && order.driver" :driver="order.driver" :key="order.driver.id" class="driver-item"/>
        <div class="order">
            <div class="top" :style="topStyle" v-show="!isProcessing">
                <div class="status">
                    <div class="status-text">
                        {{ status }}
                    </div>
                    <div class="status-context">
                        <div class="left">
                            <img src="@/assets/img/time.svg">
                            {{ timeStatus }}
                        </div>
                        <div class="right" v-show="order.status === 'missing'" @click="restart">
                            重新配對
                            <img src="@/assets/img/next-white.png">
                        </div>
                        <div class="right" v-show="order.is_debt" @click="onPay">
                            前往繳款
                            <img src="@/assets/img/next-white.png">
                        </div>
                    </div>
                </div>
                <div class="status-button" v-if="isDone && !order.is_debt" @click="onScore">
                    <div v-if="order.scores.length">
                        <img src="@/assets/img/star-white.svg">
                        <div>
                            查看評價
                        </div>
                    </div>
                    <div v-else>
                        <img src="@/assets/img/star-empty-white.svg">
                        <div>
                            前往評價
                        </div>
                    </div>
                </div>
            </div>
            <div class="driver-info" v-show="!isProcessing">
                <div class="driver" v-if="order.driver && !isDesignate">
                    <div class="avatar" :style="driverAvatarStyle"/>
                    <div class="name">
                        #{{ order.driver.knight_id }} {{ order.driver.name }}
                    </div>
                    <div class="block" @click.stop="toggleBlock">
                        <img v-show="!isBlock" src="@/assets/img/block.svg">
                        <img v-show="isBlock" src="@/assets/img/block-active.svg">
                    </div>
                    <div class="favorite" @click.stop="toggleFavorite">
                        <img v-show="!isFavorite" src="@/assets/img//heart.svg">
                        <img v-show="isFavorite" src="@/assets/img/heart-active.svg">
                    </div>
                    <div class="chat" @click.stop="onDriverMessage">
                        <img src="@/assets/img/chat.svg">
                    </div>
                    <div class="tag" v-if="order.driver.id == order.designated_driver_id">指定</div>
                </div>
                <div class="driver-note" v-if="order.status === 'done' && order.driver_note_photos.length > 0">
                    <div class="icon" :style="driverNotePhotoStyle">
                        <div class="photo" v-for="photo in order.driver_note_photos" :key="photo.id" :style="photoStyle(photo)">
                            <img v-gallery="'order-' + order.id" :src="photo.url">
                        </div>
                    </div>
                    <div class="content" ref="driverNoteContent">
                        <span>備註：</span>
                        <pre class="msg" v-show="order.driver_note">{{ order.driver_note }}</pre>
                    </div>
                </div>
            </div>
            <div class="row" v-for="(location, index) in order.locations" :key="location.id">
                <location-item :location="location" :is-done="isDone" :location-index="index+1" :order="order"/>
            </div>
            <div class="row" v-show="order.credit_logs && order.credit_logs.length > 0">
                <div class="log">
                    <div class="log-header">
                        刷卡明細
                    </div>
                    <div class="log-body" v-for="log in order.credit_logs" :key="log.id">
                        <div class="title">
                            {{ log.text }}
                        </div>
                        <div class="amount">
                            <span v-show="log.action === 'refund' || log.action === 'special_refund'">- </span>
                            $ {{ log.amount }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="price" v-if="order.prices.fixed">
                    <div class="item"
                         :class="{'gray': !order.prices.base}">
                        <div>基本費用</div>
                        <div>$ {{ 0 }}</div>
                    </div>
                    <div class="item">
                        <div>產品費用</div>
                        <div>$ {{ order.prices.fixed }}</div>
                    </div>
                    <div class="item"
                         :class="{'gray': !order.prices.tip}">
                        <div>急件費用</div>
                        <div>$ {{ order.prices.tip }}</div>
                    </div>
                    <div class="item"
                         :class="{'gray': !order.prices.discount}">
                        <div>折扣費用</div>
                        <div>- $ {{ Math.max(order.prices.discount_max, order.prices.discount) }}</div>
                    </div>
                    <div class="item footer">
                        <div>線上支付</div>
                        <div>總計 $ {{ order.prices.fixed - order.prices.discount + order.prices.tip }}</div>
                    </div>
                </div>
                <div class="price" v-else>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.behalf)"
                         :class="{'gray': !order.prices.behalf}">
                        <div>代付費用</div>
                        <div>$ {{ order.prices.behalf }}</div>
                    </div>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.base)"
                         :class="{'gray': !order.prices.base}">
                        <div>基本費用</div>
                        <div>$ {{ order.prices.base }}</div>
                    </div>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.distance)"
                         :class="{'gray': !order.prices.distance}">
                        <div>距離費用</div>
                        <div class="gray">共 {{ Math.round(order.distance / 10) / 100 }} 公里</div>
                        <div>$ {{ order.prices.distance }}</div>
                    </div>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.multiple)"
                         :class="{'gray': !order.prices.multiple}">
                        <div>多點費用</div>
                        <div>$ {{ order.prices.multiple }}</div>
                    </div>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.wait)"
                         :class="{'gray': !order.prices.wait}">
                        <div>等待費用</div>
                        <div>$ {{ order.prices.wait }}</div>
                    </div>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.tip)"
                         :class="{'gray': !order.prices.tip}">
                        <div>急件費用</div>
                        <div>$ {{ order.prices.tip }}</div>
                    </div>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.discount)"
                         :class="{'gray': !order.prices.discount}">
                        <div>折扣費用</div>
                        <div>- $ {{ Math.max(order.prices.discount_max, order.prices.discount) }}</div>
                    </div>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.fee)"
                         :class="{'gray': !order.prices.fee}">
                        <div>服務費用</div>
                        <div>$ {{ order.prices.fee }}</div>
                    </div>
                    <div class="item"
                         v-show="!(collapsed && !order.prices.donate)"
                         :class="{'gray': !order.prices.donate}">
                        <div>打賞金額</div>
                        <div>$ {{ order.prices.donate }}</div>
                    </div>
                    <div class="item footer">
                        <div>{{ order.pay === 'cash' ? '現金支付' : '線上支付' }}</div>
                        <div>總計 $ {{ price }}</div>
                    </div>
                    <div class="more" @click="collapsed = !collapsed">
                        <img src="@/assets/img/more-gray.png" :class="{'collapsed': !collapsed}">
                    </div>
                </div>
            </div>
            <div class="del" v-if="isDone">
                <div class="btn" @click="deleteOrder">想要刪除紀錄？</div>
            </div>
            <div class="buttons" v-show="!isDesignate">
                <div class="button red" v-if="order.is_debt" @click="onPay">
                    前往付款
                </div>
                <div class="two" v-else-if="isDispatching">
                    <div class="button left" @click="cancel">取消配對</div>
                    <div class="button right" @click="showTip = true">增加急件費用</div>
                </div>
                <div class="two" v-else-if="isMissing">
                    <div class="button left red" @click="cancel">取消配對</div>
                    <div class="button right red" @click="restart">重新配對</div>
                </div>
                <div class="two" v-else-if="isDone">
                    <div class="button left" @click.stop="showDonate = true">打賞</div>
                    <div class="button right red" @click="copyOrder">再訂一次</div>
                </div>
                <div class="button red" @click="cancel" v-else>
                    取消任務
                </div>
                <loading loader="spinner"
                         :active="isLoading"
                         :width="25"
                         :height="25"/>
            </div>
            <set-tip v-if="showTip" @onCancel="showTip = false" @onDone="setTip" :default-tip="order.prices.tip"/>
            <tip-modal ref="tipModal"/>
            <tip-up-modal ref="tipUpModal"/>
        </div>
        <div class="page-footer" v-show="isDesignate && cart.driver && order.driver && cart.driver.id == order.driver.id">
            <div class="button" @click.stop="confirmDesignate">
                指定騎士
            </div>
        </div>
        <delete-order ref="deleteModal" @onConfirm="onConfirm"/>
        <add-donate v-if="showDonate" :order-id="orderId" @onDone="showDonate=false" @onCancel="showDonate = false"/>
        <block-knight ref="blockModal" />
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Header from './components/Header'
    import moment from 'moment';
    import LocationItem from './components/order/list/LocationItem';
    import SetTip from './components/order/AddTip';
    import TipModal from './components/modal/TipReduceModal';
    import Loading from 'vue-loading-overlay';
    import TipUpModal from './components/modal/TipUpModal';
    import Swal from 'sweetalert2'
    import DriverItem from "./components/designate/DriverItem";
    import {addDriver, deleteDriver, unblockDriver} from "../apis";
    import DeleteModal from "./components/modal/DeleteOrderModal";
    import BlockKnightModal from "./components/modal/BlockKnightModal";
    import AddDonate from "./components/order/AddDonate";

    export default {
        name: 'Order',
        components: {
            'p-header': Header,
            'location-item': LocationItem,
            'set-tip': SetTip,
            'tip-modal': TipModal,
            'loading': Loading,
            'tip-up-modal': TipUpModal,
            'driver-item': DriverItem,
            'delete-order': DeleteModal,
            'block-knight': BlockKnightModal,
            'add-donate': AddDonate,
        },
        data() {
            return {
                orderId: 0,
                collapsed: true,
                showTip: false,
                isLoading: false,
                isDesignate: false,
                designateName: '',
                designateType: null,
                driverContentHeight: '1em',
                showDonate: false,
            }
        },
        computed: {
            driverNotePhotoStyle() {
                return {
                    'height': this.driverContentHeight,
                    'min-height': '26px',
                };
            },
            driverAvatarStyle() {
                let url = require('@/assets/img/driver/default-avatar.svg');
                if (this.order.driver && this.order.driver.avatar) {
                    url = this.order.driver.avatar.url;
                }
                return {
                    'background-image': `url("${url}")`
                }
            },
            leftBtn() {
                return this.isDone && !this.isDesignate && !this.order.score ? '評價' : '';
            },
            isDone() {
                return ['done', 'cancel', 'revoke'].indexOf(this.order.status) >= 0;
            },
            isProcessing() {
                return this.order.status === 'processing';
            },
            isMissing() {
                return this.order.status === 'missing'
            },
            isDispatching() {
                return ['dispatching', 'sending'].indexOf(this.order.status) >= 0;
            },
            price() {
                if (! this.order.id) {
                    return 0;
                }

                return Math.max(parseInt(this.order.prices.base || 0) +
                    parseInt(this.order.prices.distance || 0) +
                    parseInt(this.order.prices.multiple || 0) +
                    parseInt(this.order.prices.tip || 0) -
                    parseInt(this.order.prices.discount || 0) +
                    parseInt(this.order.prices.wait || 0) +
                    parseInt(this.order.prices.fee || 0) +
                    parseInt(this.order.prices.behalf || 0) -
                    parseInt(this.order.prices.discount_surplus || 0), 0)
            },
            timeStatus() {
                if (this.order.is_debt) {
                    return '需結清才能使用';
                }

                if (this.order.reserved_at) {
                    return `任務開始時間 ${moment(this.order.reserved_at).format('MM/DD HH:mm')}`;
                }

                return '馬上出發';
            },
            topStyle() {
                let color;
                switch (this.order.status) {
                    case 'preparing':
                    case 'sending':
                    case 'dispatching':
                        color = '#4A90E2';
                        break;
                    case 'missing':
                        color = '#F44336';
                        break;
                    case 'processing':
                        color = '#339933';
                        break;
                    case 'done':
                    case 'revoke':
                    case 'cancel':
                    case 'abstention':
                        color = '#9B9B9B';
                        break;
                    default:
                        color = '#F44336';
                }

                if (this.order.is_debt) {
                    color = '#F44336';
                }

                return {
                    'background-color': color,
                    'border-radius': '5px',
                }
            },
            status() {
                if (this.order.is_debt) {
                    return '任務尚有欠款';
                }

                if (this.order.status_text === '預約成功') {
                    return '任務預約成功';
                }

                switch (this.order.status) {
                    case 'preparing':
                        return '任務填寫中';
                    case 'sending':
                    case 'dispatching':
                    case 'appointing':
                        return '任務配對中';
                    case 'missing':
                        return '任務配對失敗';
                    case 'processing':
                        return '任務執行中';
                    case 'done':
                        return '任務已完成';
                    case 'revoke':
                    case 'cancel':
                    case 'abstention':
                        return '任務已取消';
                    default:
                        return '未知狀態';
                }
            },
            date() {
                if (! this.order.id) {
                    return '';
                }

                let date = moment(this.order.reserved_at || this.order.sent_at);
                let now = moment();

                if (now.format('YYYY/MM/DD') === date.format('YYYY/MM/DD')) {
                    return '今天 ' + date.format('MM/DD');
                }

                if (now.clone().add(1, 'days').format('YYYY/MM/DD') === date.format('YYYY/MM/DD')) {
                    return '明天 ' + date.format('MM/DD');
                }

                if (now.clone().add(1, 'days').format('YYYY/MM/DD') === date.format('YYYY/MM/DD')) {
                    return '後天 ' + date.format('MM/DD');
                }

                return date.format('MM/DD');
            },
            time() {
                if (! this.order.id) {
                    return '';
                }

                return moment(this.order.reserved_at || this.order.sent_at).format('HH:mm');
            },
            order() {
                return this.orderById(this.orderId) || {
                    driver_note_photos: [],
                    prices: {
                        behalf: 0,
                        base: 0,
                        distance: 0,
                        multiple: 0,
                        wait: 0,
                        tip: 0,
                        discount: 0,
                        discount_surplus: 0,
                        discount_max: 0,
                    }
                };
            },
            headerTitle() {
                return `任務編號 #${this.orderId}`;
            },
            isFavorite() {
                return this.driverIds.findIndex(id => id == this.order.driver.knight_id) >= 0;
            },
            isBlock() {
                return this.blockIds.findIndex(id => id == this.order.driver.knight_id) >= 0;
            },
            ...mapGetters(['orderById', 'isLineMini', 'cart', 'driverIds', 'blockIds'])
        },
        methods: {
            deleteOrder() {
                this.$refs.deleteModal.show(this.orderId);
            },
            onConfirm() {
                this.$router.replace({
                    name: 'orders'
                })
            },
            photoStyle(photo) {
                return {
                    'background-image': `url(${photo.url})`
                }
            },
            onMessage() {
                window.open('https://line.me/R/ti/p/%40hjc7084c', "_blank");
            },
            onDriverMessage() {
                this.$router.push({
                    name: 'message',
                    params: {
                        id: this.order.id,
                    }
                });
            },
            cancel() {
                this.$router.push({
                    name: 'orderEdit',
                    params: {
                        id: this.order.id
                    },
                })
            },
            copyOrder() {
                this.copyBuyOrder(this.order).then(page => {
                    this.$router.push({
                        name: page,
                    })
                });
            },
            restart() {
                this.isLoading = true;

                this.restartOrder(this.order.id).then(() => {
                    this.isLoading = false;
                }).catch(err => {
                    this.isLoading = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                })
            },
            setTip(tip) {
                this.showTip = false;

                if (tip <= this.order.prices.tip) {
                    this.$refs.tipModal.show();
                    return;
                }

                this.$refs.tipUpModal.show(tip, this.order.id);
            },
            onScore() {
                this.$router.push({
                    name: 'score',
                    params: {
                        id: this.order.id,
                    }
                });
            },
            onPay() {
                window.open(`/api/payments/${this.order.id}/credit`, '_new');
            },
            confirmDesignate() {
                this.confirmDriver();
                this.$router.go(this.designateName === 'ordersList' ? -3 : -2);
            },
            toggleFavorite() {
                let ApiRequests = [
                    this.isFavorite ? deleteDriver(this.order.driver.knight_id) : addDriver(this.order.driver.knight_id),
                ];

                Promise.all(ApiRequests).then(() => {
                    this.getDriverIds();
                });
            },
            toggleBlock() {
                if (!this.isBlock) {
                    return this.$refs.blockModal.show(this.order.driver.knight_id);
                }

                let ApiRequests = [
                    unblockDriver(this.order.driver.knight_id),
                ];

                Promise.all(ApiRequests).then(() => {
                    this.getBlockIds();
                });
            },
            ...mapActions(['getOrder', 'putOrder', 'restartOrder', 'copyBuyOrder', 'confirmDriver', 'getDriverIds', 'getBlockIds'])
        },
        created() {
            this.orderId = this.$route.params.id;
            this.isDesignate = this.$route.params.designate || false;
            this.designateType = this.$route.params.designate_type || null;
            this.designateName = this.$route.params.name || '';

            let payload = {
                id: this.orderId,
                data: {
                    'logs': true,
                }
            }

            if (this.isDesignate) {
                payload.data.is_designate = this.isDesignate;
                payload.data.designate_type = this.designateType;
            }

            this.getOrder(payload).catch(err => {
                if (err.response.status === 403 || err.response.status === 404) {
                    this.$router.replace({
                        name: 'home'
                    })
                }
            })
        },
        watch: {
            order() {
                this.$nextTick(() => {
                    if (this.$refs.driverNoteContent) {
                        this.driverContentHeight = this.$refs.driverNoteContent.getBoundingClientRect().height + 'px';
                    }
                });
            }
        },
        beforeRouteLeave(to, from, next) {
            if (to.name === 'timeline' && ['done', 'cancel', 'revoke', 'abstention'].indexOf(this.order.status) >= 0) {
                return this.$router.go(-2);
            }

            return next();
        }
    };
</script>

<style lang="scss" scoped>
    .main {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .row {
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        line-height: 18px;
        margin: 10px 0;
        border-radius: 5px;
        background-color: #FFFFFF;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
    }

    .del {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 25px;
        .btn {
            font-size: 14px;
            font-style: italic;
            cursor: pointer;
            text-decoration: underline;
            color: #FF7373;
        }
    }

    .driver-item {
        margin: 15px;
    }

    .top {
        text-align: left;
        display: flex;

        .status-button {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 12px;
            background-color: #339933;
            color: #FFFFFF;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            border-radius: 0 5px 5px 0;
            border-left: #FFFFFF solid 2px;
            cursor: pointer;
            user-select: none;
            width: 80px;

            div {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                img {
                    margin-bottom: 10px;
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .status {
            flex:  1;

            .status-text {
                color: #FFFFFF;
                font-size: 24px;
                font-weight: 600;
                letter-spacing: 0;
                line-height: 36px;
                padding: 10px;
            }

            .status-context {
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: #FFFFFF;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 20px;
                padding-bottom: 10px;
                padding-left: 10px;

                .left {
                    display: flex;
                    align-items: center;
                    img {
                        margin-right: 5px;
                    }
                }

                .right {
                    cursor: pointer;
                    user-select: none;
                    display: flex;
                    align-items: center;
                    background-color: #000;
                    padding: 3px 10px;
                    border-radius: 23px 0 0 23px;
                }
            }
        }
    }

    .driver-info {
        border-radius: 5px;
        background-color: #FFFFFF;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
    }

    .driver-note {
        user-select: none;
        display: flex;
        padding: 8px 15px;
        align-items: center;
        border-radius: 0 0 5px 5px;
        background-color: #FAFAFA;

        .icon {
            display: flex;
            align-self: flex-start;

            .photo {
                display: flex;
                min-height: 26px;
                max-height: 62px;
                width: 62px;
                border-radius: 5px;
                background-color: #D8D8D8;
                background-position: 50% 50%;
                background-size: cover;
                background-repeat: no-repeat;

                &:not(:last-child) {
                    margin-right: 10px;
                }

                img {
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                    filter: alpha(opacity=0);
                }
            }
        }

        .content {
            display: flex;
            margin-left: 15px;

            span {
                color: #9B9B9B;
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 20px;
                width: 60px;
            }

            pre {
                margin: 0;
                color: #4A4A4A;
                font-size: 14px;
                white-space: pre-wrap;
                text-align: initial;
            }
        }
    }

    .order {
        margin: 0 15px;
        position: relative;
        padding-bottom: 70px;
        box-sizing: border-box;
        flex: 1;

        .driver {
            display: flex;
            border-radius: 2px;
            background-color: #FFFFFF;
            padding: 8px 15px;
            margin-top: 10px;
            align-items: center;
            position: relative;
            justify-content: space-between;

            .avatar {
                height: 40px;
                width: 40px;
                border-radius: 90px;
                background-position: 50% 50%;
                background-size: cover;
                margin-right: 15px;
            }

            .name {
                color: #000000;
                font-size: 14px;
                flex: 1;
                text-align: left;
            }

            .favorite {
                cursor: pointer;
                user-select: none;

                img {
                    height: 15px;
                    width: 15px;
                }
            }

            .block {
                cursor: pointer;
                user-select: none;
                margin-right: 15px;

                img {
                    height: 15px;
                    width: 15px;
                }
            }

            .chat {
                margin-left: 15px;
                cursor: pointer;
                user-select: none;

                img {
                    height: 20px;
                    width: 20px;
                }
            }

            .tag {
                position: absolute;
                top: -12px;
                right: 4px;
                background-color: red;
                color: #ffffff;
                padding: 1px 7px;
                font-size: 13px;
                font-weight: 600;
                border: 2px #ffffff solid;
                border-radius: 5px;
            }
        }
    }

    .price {
        margin: 10px 15px;
        width: 100%;
        font-size: 13px;
        line-height: 18px;
        color: #4A4A4A;
        position: relative;

        .item {
            margin: 10px 0;
            display: flex;
            justify-content: space-between;

            &.gray {
                color: #9B9B9B;
            }

            div {
                &.gray {
                    color: #9B9B9B;
                }
            }

            &.footer {
                color: #000000;
                font-size: 16px;
                line-height: 22px;
            }
        }

        .more {
            position: absolute;
            left: calc(50% - 17px);
            bottom: -32px;

            img {
                height: 34px;
                width: 34px;

                &.collapsed {
                    transform: rotate(180deg);
                }
            }
        }
    }

    .page-footer {
        padding: 15px;
        position: fixed;
        bottom: 0;
        width: calc(100% - 30px);
        max-width: 470px;
        background-color: #ffffff;

        .button {
            cursor: pointer;
            user-select: none;
            background-color: #339933;
            padding: 13px;
            border-radius: 35px;
            color: #FFF;
            font-size: 14px;
        }
    }

    .buttons {
        position: absolute;
        width: 100%;
        bottom: 0;
        color: #FFFFFF;
        font-size: 14px;
        line-height: 20px;
        text-align: center;

        .button {
            margin: 10px 0;
            border-radius: 35px;
            background-color: #FF9999;
            padding: 13px;
        }

        .two {
            display: flex;

            .button {
                padding: auto 12px;
                &.left {
                    background-color: #7ABC7A;
                    border-radius: 35px 0 0 35px;
                    width: 30%;

                    &.red {
                        background-color: #FF7373;
                    }
                }

                &.right {
                    background-color: #339933;
                    width: 70%;
                    border-radius: 0 35px 35px 0;

                    &.red {
                        background-color: #FF9999;
                    }
                }
            }
        }
    }

    .log {
        flex: 1;
        .log-header {
            background-color: #4A4A4A;
            border-radius: 6px 6px 0 0;
            padding: 10px;
            color: #fff;
            font-size: 16px;
            font-weight: 500;
        }

        .log-body {
            padding: 5px 15px;
            display: flex;
            justify-content: space-between;
        }
    }
</style>
